module.exports = __webpack_public_path__ + "static/media/20150815_064808.e65a69fe.jpg";